import { useParams } from 'react-router'
import { FormattedDate, FormattedMessage, FormattedTime } from 'react-intl'
import SpreadsheetTable from '@components/SpreadsheetTable/SpreadsheetTable'
import { ColumnDefinition } from 'src/types/tableDataSet'
import { useDataset } from '@hooks/useDataset'
import BackButton from '@components/BackButton/BackButton'

import './TableData.css'

export default function TableData() {
  const { companyId, datasetId } = useParams()
  const { data, pagination, company, dataset } = useDataset(
    companyId,
    datasetId
  )

  if (data.length === 0) {
    return (
      <div id="table-data-set">
        <FormattedMessage id="dataset.table-data.empty" />
      </div>
    )
  }

  const rows = data.map((x) => Object.values(x))
  const cols: ColumnDefinition[] = Object.keys(data[0]).map((k) => ({
    col: k,
    label: k,
    type: 'number'
  }))

  return (
    <div className="container">
      <div id="table-data">
        <BackButton />
        <h2>
          <span>Empresa: </span>
          <strong>{company.name}</strong>
        </h2>
        <h1>
          <span className="icon icon-table" />
          <span>{dataset.title}</span>
        </h1>
        <p className="updated-date">
          Actualizado: <span className="icon icon-calendar" />
          {dataset.lastUpdate && (
            <>
              <strong>
                <FormattedDate
                  value={dataset.lastUpdate}
                  day="2-digit"
                  month="2-digit"
                  year="2-digit"
                />
              </strong>
              <span className="icon icon-clock" />
              <strong>
                <FormattedTime value={dataset.lastUpdate} />
              </strong>
            </>
          )}
          {!dataset.lastUpdate && <span>Desconocido</span>}
        </p>
      </div>
      <div className="table-wrapper">
        <SpreadsheetTable
          columnsDef={cols}
          rows={rows}
          pageSize={pagination?.itemsPerPage}
          currentPage={pagination?.page}
          idColumnIndex={0}
        />
      </div>
    </div>
  )
}
